import React from 'react';
import { Button } from './button';

const SessionWarningModal = ({ 
  isVisible, 
  timeRemaining, 
  onExtendSession, 
  onLogout,
  formatTimeRemaining 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-center mb-4">
          <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg 
              className="w-6 h-6 text-yellow-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" 
              />
            </svg>
          </div>
        </div>
        
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Session Expiring Soon
          </h2>
          <p className="text-gray-600 mb-4">
            Your session will expire in:
          </p>
          <div className="text-2xl font-bold text-red-600 mb-2">
            {formatTimeRemaining(timeRemaining)}
          </div>
          <p className="text-sm text-gray-500">
            Click "Stay Logged In" to continue your session or "Logout" to end it now.
          </p>
        </div>

        <div className="flex space-x-3">
          <Button
            onClick={onExtendSession}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
          >
            Stay Logged In
          </Button>
          <Button
            onClick={onLogout}
            variant="outline"
            className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningModal;